import { FirestoreImagesDocument } from '@/types/firestore';

/**
 * Returns the best available URL for displaying an image.
 * `thumbnailURL` is set asynchronously by a background job after upload,
 * so it may be absent on documents created before the job completes.
 * Falls back to `imageURL` to keep display working in the interim.
 */
export function getImageDisplayUrl(doc: FirestoreImagesDocument): string;
export function getImageDisplayUrl(
    doc: FirestoreImagesDocument | null | undefined,
): string | undefined;
export function getImageDisplayUrl(
    doc: FirestoreImagesDocument | null | undefined,
): string | undefined {
    return doc?.thumbnailURL ?? doc?.imageURL;
}
